import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { HlrCurrencies } from '@helpers/types/models';
import { exist } from '@campaign-portal/namespace/common/id';
import { CurrenciesService } from '../currencies.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-currencies-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CurrenciesDialogComponent {

	private readonly destroyRef = inject(DestroyRef);
	
	constructor(
			@Inject(DIALOG_DATA) public readonly data: { currency: HlrCurrencies<exist> },
			public readonly currenciesService: CurrenciesService,
			private readonly dialogRef: DialogRef<boolean>
	) {
	}
	
	confirm(): void {
		this.currenciesService.delete({ id: this.data.currency.id })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.deleted ) {
					this.dialogRef.close(true);
				}
			});
	}
	
	close(): void {
		this.dialogRef.close(false);
	}
}
